import { useTranslate } from "common/utilities/useTranslate";
import { UpgradeModal } from "domains/modal/components/UpgradeModal";

export const CreateCustomDimensionUpgradeModal = () => {
  const translate = useTranslate();

  return (
    <UpgradeModal
      buttonText={translate("app.create.upgrade.custom_key_issue.primary_button")}
      buttonTrackMeta={{ page: "Create", subpage: "Create custom key issue" }}
      message={translate("app.create.upgrade.custom_key_issue.text")}
      title={translate("app.create.upgrade.custom_key_issue.title")}
    />
  );
};
